import './SimpleTimeTargetProgress.css';

import React from 'react';
import { AdsClick, DateRange } from '@mui/icons-material';
import { LinearProgress } from '@mui/material';
import { generateClassName } from '../../../b2b-common/helpers';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const SimpleTimeTargetProgress = ({ targetProgress, timeProgress,
    showCalendarProgress = true, showTargetProgress = true, className = null, locale = null
}) => {
    const { t } = useB2BTranslation('b2b-plans', locale);
    
    const fullWidth = !(showCalendarProgress && showTargetProgress);
    return (
        (showCalendarProgress || showTargetProgress) ? (
            <div className={`${generateClassName('simple-time-target-progress', '', className)} ${fullWidth ? 'full-width' : ''}`}>
                {showCalendarProgress && (
                    <div className='simple-time-target-progress-time'>
                        <DateRange className='simple-time-target-progress-time-icon' />
                        <div className='simple-time-target-progress-time-data'>
                            <LinearProgress variant='determinate' value={Math.min(100, timeProgress)} className={'simple-time-linear-progress'} />
                            <div className='simple-time-target-progress-time-target-value'>{`${timeProgress}% ${t('of calendar progress')}`}</div>
                        </div>
                    </div>
                )}
                {showTargetProgress && (
                    <div className='simple-time-target-progress-target'>
                        <AdsClick className='simple-time-target-progress-target-icon' />
                        <div className='simple-time-target-progress-target-data'>
                            <LinearProgress variant='determinate' value={Math.min(100, targetProgress)} className={'simple-target-linear-progress'} />
                            <div className='simple-time-target-progress-time-target-value'>{`${targetProgress}%  ${t('of the objective')}`}</div>
                        </div>
                    </div>
                )}
            </div>
        ) : null
    );
}

export default SimpleTimeTargetProgress;